/* tslint:disable */
export const consoleMessage = `
                                        ▓▓
                                      ▓▓▓▓
                                        ▓▓
                                        ▓▓
                            ▓▓▓▓▓       ▓▓
                          ▓▓▓   ▓▓▓     ▓▓
                         ▓▓       ▓▓    ▓▓
                         ▓▓       ▓▓    ▓▓
                         ▓▓       ▓▓
              ▓▓▓▓▓▓▓     ▓▓▓   ▓▓▓          ▓▓▓▓▓▓▓
            ▓▓▓▓▓▓▓▓       ▓▓▓▓▓▓▓            ▓▓▓▓▓▓▓▓
            ▓▓▓▓▓▓        ▓▓▓▓▓▓▓▓▓▓▓▓▓          ▓▓▓▓▓
            ▓▓▓▓▓  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓   ▓▓▓▓▓
    ▓▓▓     ▓▓▓▓▓  ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓  ▓▓▓▓▓
  ▓▓▓       ▓▓▓▓▓       ▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓▓    ▓▓▓▓▓
▓▓▓▓        ▓▓▓▓▓                  ▓▓▓    ▓▓▓    ▓▓▓▓▓▓
▓▓▓▓       ▓▓▓▓▓                   ▓▓▓    ▓▓▓     ▓▓▓▓▓
▓▓▓▓      ▓▓▓▓▓▓                   ▓▓▓    ▓▓▓     ▓▓▓▓▓▓
▓▓▓▓     ▓▓▓▓▓▓                    ▓▓▓    ▓▓▓      ▓▓▓▓▓▓
▓▓▓▓    ▓▓▓▓▓▓                     ▓▓▓    ▓▓▓       ▓▓▓▓▓▓
▓▓▓▓     ▓▓▓▓▓▓                    ▓▓▓    ▓▓▓      ▓▓▓▓▓▓
▓▓▓▓       ▓▓▓▓▓                   ▓▓▓    ▓▓      ▓▓▓▓▓
 ▓▓▓        ▓▓▓▓                   ▓▓▓            ▓▓▓▓
  ▓▓▓       ▓▓▓▓▓                  ▓▓▓           ▓▓▓▓▓
    ▓▓▓     ▓▓▓▓▓                  ▓▓            ▓▓▓▓▓
            ▓▓▓▓▓                                ▓▓▓▓▓
            ▓▓▓▓▓▓                               ▓▓▓▓▓
            ▓▓▓▓▓▓▓▓                          ▓▓▓▓▓▓▓▓
              ▓▓▓▓▓▓▓                        ▓▓▓▓▓▓▓▓

Welcome to Binary Coffee console, if you see any bug or issue, do not hesitate to inform us. Remember that our code is completely open-source so visit our repo if you want to contribute.
https://github.com/binary-coffee-dev


`;
